import { useEffect } from 'react';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Supports from './components/Supports';
import WhyUs from './components/WhyUs';
import Area from './components/Area';
import Contact from './components/Contact';
import Apply from './components/Apply';
import Footer from './components/Footer';

export default function App() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <div className="bg-brand-cream text-navy font-body overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Supports />
        <WhyUs />
        <Area />
        <Contact />
        <Apply />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
